// Service page data with SEO optimization, FAQ schema, and EEAT content
export const BUSINESS_INFO = {
  name: "Dallas Haul Stars LLC",
  phone: "972-330-3678",
  email: "info@dallashaulstars.com",
  contactEmail: "info@dallashaulstars.com",
  url: "https://dallashaulstars.com",
  logo: "https://customer-assets.emergentagent.com/job_trash-haulers-tx/artifacts/52ejxn9j_dallas%20haul%20stars.jpg",
  facebook: "https://www.facebook.com/p/Dallas-Haul-Stars-LLC-61574536672374/",
  address: {
    streetAddress: "Dallas",
    addressLocality: "Dallas",
    addressRegion: "TX",
    postalCode: "75201",
    addressCountry: "US"
  },
  geo: {
    latitude: "32.7767",
    longitude: "-96.7970"
  },
  areaServed: [
    "Dallas", "Plano", "Irving", "Garland", "Richardson", "Carrollton",
    "Mesquite", "Grand Prairie", "Arlington", "Frisco", "McKinney", "Allen",
    "Lewisville", "Flower Mound", "Denton", "The Colony", "Addison", "Farmers Branch"
  ],
  openingHours: "Mo-Sa 07:00-19:00",
  priceRange: "$$"
};

export const SERVICES_DATA = {
  "residential-junk-removal": {
    id: "residential",
    slug: "residential-junk-removal",
    // SEO Meta Tags
    title: "Residential Junk Removal Dallas TX | Same-Day Home Cleanouts",
    metaDescription: "Professional residential junk removal services in Dallas, TX. We clear garages, attics, basements & full house cleanouts. Free estimates, same-day service. Call 972-330-3678.",
    // Page Content
    h1: "Residential Junk Removal Services in Dallas, TX",
    heroSubtitle: "Trusted Home Junk Removal Experts Serving the Dallas-Fort Worth Metroplex",
    icon: "Home",
    image: "https://images.unsplash.com/photo-1635108198854-26645ffe6714?w=1200&auto=format&fit=crop&q=80",
    imageAlt: "Residential garage cleanout and junk removal service in Dallas",
    // Service Details
    shortDescription: "Clear out garages, attics, basements, and homes. We handle everything from single items to full house cleanouts.",
    features: ["Single Item Pickup", "Full House Cleanouts", "Estate Cleanouts", "Garage Cleanouts", "Attic & Basement Clearing", "Yard Debris Removal"],
    // EEAT Content Sections
    sections: [
      {
        h2: "Professional Home Junk Removal You Can Trust",
        content: "Dallas Haul Stars provides reliable residential junk removal services throughout the Dallas-Fort Worth area. Whether you're decluttering your garage, cleaning out an attic, or preparing for a move, our experienced team handles all the heavy lifting so you don't have to. We're licensed, insured, and committed to responsible disposal practices."
      },
      {
        h2: "What We Remove From Your Home",
        content: "Our residential junk removal service covers virtually anything non-hazardous in your home. We regularly haul away old furniture, broken appliances, mattresses, electronics, yard waste, and accumulated household clutter. No job is too big or too small—from a single item pickup to a complete whole-house cleanout.",
        list: [
          "Old furniture (sofas, chairs, tables, dressers)",
          "Mattresses, box springs, and bed frames",
          "Electronics and e-waste",
          "Exercise equipment and sporting goods",
          "Yard debris, branches, and landscaping waste",
          "Boxes, packing materials, and general household junk"
        ]
      },
      {
        h2: "Our Residential Junk Removal Process",
        content: "We've streamlined our process to make junk removal as easy as possible for Dallas homeowners:",
        steps: [
          { title: "Schedule Your Appointment", description: "Call us at 972-330-3678 or fill out our online form. We offer same-day and next-day appointments." },
          { title: "Get Your Free On-Site Quote", description: "Our team arrives at your scheduled time, assesses the items, and provides an upfront, no-obligation price." },
          { title: "We Haul It All Away", description: "Approve the quote and we get to work immediately. We do all the lifting, loading, and cleanup." }
        ]
      },
      {
        h2: "Why Dallas Homeowners Choose Us",
        content: "Dallas Haul Stars has earned a 5-star reputation for residential junk removal because we prioritize customer satisfaction and environmental responsibility. We recycle and donate items whenever possible, ensuring your unwanted belongings don't just end up in a landfill. Our pricing is transparent with no hidden fees, and we always leave your space clean and clutter-free."
      },
      {
        h2: "Service Areas for Residential Junk Removal",
        content: "We provide home junk removal services throughout the Dallas-Fort Worth metroplex, including Dallas, Plano, Irving, Garland, Richardson, Carrollton, Mesquite, Grand Prairie, Arlington, Frisco, McKinney, Allen, Lewisville, Flower Mound, Denton, The Colony, Addison, and Farmers Branch. Don't see your area? Give us a call—we likely serve your neighborhood."
      }
    ],
    // FAQ Schema Content
    faqs: [
      {
        question: "How much does residential junk removal cost in Dallas?",
        answer: "Residential junk removal pricing in Dallas typically ranges from $75 for single items to $500+ for full house cleanouts. At Dallas Haul Stars, we provide free on-site estimates based on the volume of items. Our pricing is transparent with no hidden fees."
      },
      {
        question: "Do you offer same-day residential junk removal?",
        answer: "Yes! Dallas Haul Stars offers same-day junk removal services for homes throughout the Dallas-Fort Worth area. Call us at 972-330-3678 before 10 AM for same-day pickup availability."
      },
      {
        question: "What items can't you remove from my home?",
        answer: "We cannot remove hazardous materials including chemicals, paint, asbestos, medical waste, or biohazardous items. However, we can handle almost everything else including old furniture, appliances, electronics, mattresses, and general household junk."
      },
      {
        question: "Do I need to be home for residential junk removal?",
        answer: "We prefer that you or someone over 18 is present to authorize the quote and show us exactly what needs to be removed. However, we can arrange for unattended pickups with prior authorization."
      },
      {
        question: "Do you donate or recycle removed items?",
        answer: "Absolutely! Dallas Haul Stars is committed to eco-friendly disposal. We partner with local charities and recycling centers to donate and recycle as many items as possible before resorting to landfill disposal."
      }
    ],
    // CTA
    ctaText: "Get Your Free Residential Junk Removal Quote",
    pricing: "Starting at $75 for single items"
  },
  "commercial-junk-removal": {
    id: "commercial",
    slug: "commercial-junk-removal",
    title: "Commercial Junk Removal Dallas TX | Office & Business Cleanouts",
    metaDescription: "Expert commercial junk removal in Dallas, TX. Office furniture removal, warehouse cleanouts, retail space clearing. Licensed, insured. Call 972-330-3678 for free estimate.",
    h1: "Commercial Junk Removal Services in Dallas, TX",
    heroSubtitle: "Professional Office & Business Cleanout Solutions for Dallas Companies",
    icon: "Building2",
    image: "https://images.unsplash.com/photo-1700809887584-0798672b1d48?w=1200&auto=format&fit=crop&q=80",
    imageAlt: "Commercial office cleanout and business junk removal in Dallas",
    shortDescription: "Office cleanouts, retail spaces, and warehouses. Keep your business clutter-free and productive.",
    features: ["Office Furniture Removal", "Equipment Disposal", "Warehouse Cleanouts", "Retail Space Clearing", "Cubicle Removal", "IT Equipment Disposal"],
    sections: [
      {
        h2: "Efficient Commercial Junk Removal for Dallas Businesses",
        content: "Dallas Haul Stars specializes in commercial junk removal services designed to minimize disruption to your business operations. We understand that time is money—our professional team works efficiently to clear your office, warehouse, or retail space so you can focus on what matters most: running your business. We're fully licensed and insured for commercial projects of any size."
      },
      {
        h2: "Commercial Items We Remove",
        content: "Our commercial junk removal service handles all types of business clutter and unwanted equipment. From a single desk to an entire floor of cubicles, we have the equipment and experience to get the job done right.",
        list: [
          "Office furniture (desks, chairs, cubicles, conference tables)",
          "Filing cabinets and storage units",
          "IT equipment, computers, monitors, and printers",
          "Retail fixtures, shelving, and display cases",
          "Warehouse racking and industrial equipment",
          "Construction debris from office renovations"
        ]
      },
      {
        h2: "Industries We Serve",
        content: "Our commercial clients span various industries across Dallas, including corporate offices, property management companies, retail stores, restaurants, medical facilities, banks, schools, and warehouses. We understand the unique requirements and regulations for each industry and dispose of all items properly."
      },
      {
        h2: "Flexible Scheduling for Minimal Business Disruption",
        content: "We know your business can't stop for junk removal. That's why Dallas Haul Stars offers flexible scheduling options including after-hours, weekend, and holiday service. We can work around your business hours to ensure minimal disruption to your employees and customers."
      },
      {
        h2: "Commercial Service Areas in Dallas-Fort Worth",
        content: "We provide commercial junk removal throughout the DFW metroplex including downtown Dallas, Plano, Irving, Richardson, Carrollton, and all surrounding business districts. Whether you're in a high-rise office building or an industrial warehouse, we'll come to you."
      }
    ],
    faqs: [
      {
        question: "Can you remove office furniture and equipment after business hours?",
        answer: "Yes! Dallas Haul Stars offers flexible scheduling including evenings, weekends, and holidays. We can work around your business hours to minimize disruption to your operations."
      },
      {
        question: "Do you provide certificates of disposal for commercial clients?",
        answer: "Yes, we can provide documentation of proper disposal for compliance and record-keeping purposes. This is especially important for IT equipment and sensitive business materials."
      },
      {
        question: "How quickly can you complete a commercial cleanout?",
        answer: "Most commercial cleanouts can be completed within 1-3 days depending on scope. We have the crew and equipment to handle large-scale projects efficiently. For urgent needs, we offer same-day service."
      },
      {
        question: "Do you handle IT equipment disposal securely?",
        answer: "Yes, we follow proper protocols for IT equipment disposal and can coordinate with data destruction services if needed. We ensure all equipment is disposed of responsibly and in compliance with regulations."
      },
      {
        question: "What's the minimum job size for commercial junk removal?",
        answer: "We have no minimum job size. Whether you need to remove a single piece of equipment or clear an entire warehouse, Dallas Haul Stars is ready to help your Dallas business."
      }
    ],
    ctaText: "Schedule Your Commercial Cleanout Today",
    pricing: "Custom quotes for commercial projects"
  },
  "furniture-removal": {
    id: "furniture",
    slug: "furniture-removal",
    title: "Furniture Removal Dallas TX | Sofa, Mattress & Couch Pickup",
    metaDescription: "Fast furniture removal in Dallas, TX. We haul sofas, mattresses, couches, beds & all household furniture. Same-day pickup available. Call 972-330-3678.",
    h1: "Furniture Removal Services in Dallas, TX",
    heroSubtitle: "Fast & Affordable Old Furniture Pickup Across Dallas-Fort Worth",
    icon: "Sofa",
    image: "https://images.unsplash.com/photo-1458225991256-551e9ddc7782?w=1200&auto=format&fit=crop&q=80",
    imageAlt: "Old couch and furniture removal service in Dallas Texas",
    shortDescription: "Old couches, mattresses, desks, and more. We do the heavy lifting so you don't have to.",
    features: ["Sofas & Couches", "Mattresses & Beds", "Tables & Chairs", "Dressers & Cabinets", "Desks & Office Furniture", "Outdoor Furniture"],
    sections: [
      {
        h2: "Professional Furniture Removal Made Easy",
        content: "Getting rid of old furniture in Dallas doesn't have to be a hassle. Dallas Haul Stars provides professional furniture removal services that save you time, energy, and the back pain of moving heavy items yourself. Our experienced team handles all the heavy lifting, from bulky sectional sofas to king-size mattresses, and ensures responsible disposal."
      },
      {
        h2: "Types of Furniture We Remove",
        content: "If it's furniture, we can haul it away. Our Dallas furniture removal service handles items of all sizes and conditions—even if it's too heavy, too worn, or simply too awkward to move yourself.",
        list: [
          "Living room furniture: sofas, couches, recliners, coffee tables",
          "Bedroom furniture: mattresses, box springs, bed frames, dressers",
          "Dining room sets: tables, chairs, china cabinets, buffets",
          "Office furniture: desks, office chairs, filing cabinets, bookcases",
          "Outdoor furniture: patio sets, deck furniture, lawn chairs",
          "Specialty items: futons, sleeper sofas, sectionals, entertainment centers"
        ]
      },
      {
        h2: "Why DIY Furniture Disposal Is a Bad Idea",
        content: "Many Dallas residents consider disposing of furniture themselves, only to discover the challenges: mattresses and sofas don't fit in regular vehicles, most landfills have specific furniture disposal requirements, and improper dumping can result in fines. Dallas Haul Stars eliminates these headaches with convenient, affordable, and responsible furniture removal."
      },
      {
        h2: "Eco-Friendly Furniture Disposal",
        content: "Not all furniture belongs in a landfill. When you choose Dallas Haul Stars for furniture removal, we assess every item for donation or recycling potential. Gently used furniture is donated to local charities, while other items are recycled whenever possible. You're not just clearing your space—you're helping the community and environment."
      },
      {
        h2: "Same-Day Furniture Pickup in Dallas",
        content: "Need that old couch gone today? Dallas Haul Stars offers same-day furniture removal throughout the Dallas-Fort Worth area. Call us before 10 AM and we can typically have your unwanted furniture hauled away the same day."
      }
    ],
    faqs: [
      {
        question: "How much does it cost to have a couch removed in Dallas?",
        answer: "Single item furniture removal in Dallas typically ranges from $75-$150 depending on the size and weight of the item. Sofas and couches usually fall within this range. Call Dallas Haul Stars at 972-330-3678 for an exact quote."
      },
      {
        question: "Will you remove a mattress from upstairs?",
        answer: "Yes! Our team is equipped to remove furniture from any level of your home, including upstairs bedrooms, basements, and apartments. There's no extra charge for stairs in most cases."
      },
      {
        question: "Do you take apart furniture before removal?",
        answer: "When necessary, yes. Our crew can disassemble bed frames, desks, and other furniture that won't fit through doorways. We bring the tools needed for safe disassembly and removal."
      },
      {
        question: "Can you donate my old furniture?",
        answer: "Absolutely! If your furniture is in gently used condition, we'll donate it to local charities. We partner with organizations throughout Dallas to give furniture a second life whenever possible."
      },
      {
        question: "What if my furniture is on the curb?",
        answer: "Curbside pickup is no problem! If you've already moved furniture outside, we can pick it up quickly without needing access to your home. Just let us know the location when you schedule."
      }
    ],
    ctaText: "Schedule Furniture Pickup Today",
    pricing: "Starting at $75 per item"
  },
  "appliance-removal": {
    id: "appliance",
    slug: "appliance-removal",
    title: "Appliance Removal Dallas TX | Refrigerator, Washer & Dryer Disposal",
    metaDescription: "Safe appliance removal in Dallas, TX. We haul refrigerators, washers, dryers, stoves & water heaters. EPA-compliant disposal. Call 972-330-3678.",
    h1: "Appliance Removal Services in Dallas, TX",
    heroSubtitle: "Safe & Responsible Appliance Disposal for Dallas Homes",
    icon: "Package",
    image: "https://images.unsplash.com/photo-1678755363068-6ba249ed21cd?w=1200&auto=format&fit=crop&q=80",
    imageAlt: "Old refrigerator and appliance removal service in Dallas",
    shortDescription: "Refrigerators, washers, dryers, and all major appliances responsibly disposed of.",
    features: ["Refrigerators & Freezers", "Washers & Dryers", "Stoves & Ovens", "Dishwashers", "Water Heaters", "HVAC Units"],
    sections: [
      {
        h2: "Expert Appliance Removal and Disposal",
        content: "Old appliances present unique disposal challenges that most Dallas homeowners aren't equipped to handle. Refrigerators contain refrigerants that must be properly reclaimed, washers and dryers are extremely heavy, and water heaters can have sediment and rust issues. Dallas Haul Stars specializes in safe, compliant appliance removal that protects both you and the environment."
      },
      {
        h2: "Appliances We Remove",
        content: "Our appliance removal service covers all major household appliances, regardless of age, condition, or brand. We have the equipment and expertise to safely disconnect and haul away even the heaviest units.",
        list: [
          "Refrigerators, freezers, and mini-fridges",
          "Washing machines and clothes dryers",
          "Stoves, ranges, and ovens (gas and electric)",
          "Dishwashers and garbage disposals",
          "Water heaters (tank and tankless)",
          "Air conditioning units and HVAC equipment",
          "Microwaves, wine coolers, and small appliances"
        ]
      },
      {
        h2: "Why Proper Appliance Disposal Matters",
        content: "Improper appliance disposal isn't just inconvenient—it's potentially illegal and environmentally harmful. Refrigerators and air conditioners contain refrigerants that damage the ozone layer if released. Many appliances contain heavy metals and other materials that require special handling. Dallas Haul Stars follows all EPA guidelines and local regulations for appliance disposal."
      },
      {
        h2: "Appliance Recycling in Dallas",
        content: "Many components of old appliances can be recycled, including metals, plastics, and glass. Dallas Haul Stars works with certified recycling facilities to ensure your old appliances are processed responsibly. Refrigerants are properly reclaimed, metals are recycled, and hazardous components are handled according to regulations."
      },
      {
        h2: "Safe Disconnection Services",
        content: "Need your old appliance disconnected before removal? Our team can safely disconnect most appliances, including turning off water lines for washing machines and dishwashers. Note: For gas appliances, we recommend having a licensed plumber handle the disconnection before our arrival."
      }
    ],
    faqs: [
      {
        question: "Do you remove refrigerators with food still inside?",
        answer: "We prefer that refrigerators are emptied before removal, but if that's not possible, we can handle it. Please note that refrigerators with food may require additional time for cleanup and proper disposal."
      },
      {
        question: "Can you disconnect my washing machine before removal?",
        answer: "Yes, our team can safely disconnect most water and electric connections for washers, dryers, and dishwashers. For gas appliances, we recommend having a licensed professional disconnect the gas line first."
      },
      {
        question: "How do you dispose of refrigerators responsibly?",
        answer: "We follow EPA regulations for refrigerator disposal. Refrigerants are reclaimed by certified technicians, and the units are processed at facilities that properly recycle metals, plastics, and other components."
      },
      {
        question: "Do you charge extra for appliance removal from basements?",
        answer: "In most cases, no. Our standard pricing covers removal from anywhere in your home, including basements and upper floors. Extremely difficult access situations may require a small additional fee, which we'll discuss upfront."
      },
      {
        question: "Can you haul away a broken water heater?",
        answer: "Yes! We remove water heaters of all types and conditions—working or not. Make sure the water and power/gas have been turned off before our arrival for safety."
      }
    ],
    ctaText: "Schedule Appliance Removal",
    pricing: "Starting at $100 per appliance"
  },
  "construction-debris-removal": {
    id: "construction",
    slug: "construction-debris-removal",
    title: "Construction Debris Removal Dallas TX | Renovation Cleanup Services",
    metaDescription: "Fast construction debris removal in Dallas, TX. Renovation cleanups, drywall, lumber, concrete hauling. Contractor-friendly pricing. Call 972-330-3678.",
    h1: "Construction Debris Removal Services in Dallas, TX",
    heroSubtitle: "Fast Renovation Cleanup & Debris Hauling for Dallas Contractors",
    icon: "HardHat",
    image: "https://images.unsplash.com/photo-1660319251342-5754112ac935?w=1200&auto=format&fit=crop&q=80",
    imageAlt: "Construction debris removal and renovation cleanup in Dallas",
    shortDescription: "Post-renovation cleanup, drywall, lumber, and construction materials hauled away fast.",
    features: ["Renovation Debris", "Drywall & Lumber", "Contractor Cleanups", "Concrete & Brick", "Roofing Materials", "Demolition Waste"],
    sections: [
      {
        h2: "Reliable Construction Debris Removal for Dallas Projects",
        content: "Whether you're a homeowner tackling a DIY renovation or a contractor managing multiple job sites, construction debris removal is an essential part of any project. Dallas Haul Stars provides fast, reliable debris hauling that keeps your project on schedule and your site clean. We understand construction timelines and work efficiently to meet your deadlines."
      },
      {
        h2: "Construction Materials We Haul",
        content: "Our construction debris removal service handles all types of building materials and renovation waste. From small bathroom remodels to major commercial renovations, we have the capacity to haul it all.",
        list: [
          "Drywall, sheetrock, and plaster",
          "Lumber, plywood, and wood scraps",
          "Concrete, brick, and masonry",
          "Roofing materials (shingles, tiles, underlayment)",
          "Flooring (carpet, tile, hardwood, laminate)",
          "Cabinets, countertops, and fixtures",
          "Windows, doors, and trim",
          "Insulation and vapor barriers"
        ]
      },
      {
        h2: "Contractor Partnership Program",
        content: "Dallas contractors choose Dallas Haul Stars because we understand the construction business. We offer priority scheduling, competitive contractor rates, and reliable service that keeps your projects moving. Many Dallas contractors partner with us for ongoing debris removal needs across multiple job sites."
      },
      {
        h2: "Same-Day and Scheduled Pickups",
        content: "Need debris removed today to pass inspection tomorrow? Dallas Haul Stars offers same-day construction debris removal throughout Dallas. We also provide scheduled recurring pickups for longer projects, so you always have a clean job site without the hassle of coordinating each pickup."
      },
      {
        h2: "Responsible Construction Waste Disposal",
        content: "Much of construction debris can be recycled. We separate materials whenever possible, diverting wood, metal, concrete, and other recyclables from landfills. This isn't just environmentally responsible—it often reduces your disposal costs."
      }
    ],
    faqs: [
      {
        question: "Can you remove concrete and brick debris?",
        answer: "Yes! Dallas Haul Stars removes all types of masonry including concrete, brick, block, and stone. Heavy materials may affect pricing, but we can handle projects of any size."
      },
      {
        question: "Do you offer ongoing service for construction sites?",
        answer: "Absolutely. Many Dallas contractors partner with us for scheduled weekly or bi-weekly pickups throughout their projects. We offer competitive rates for ongoing service arrangements."
      },
      {
        question: "How quickly can you get to my job site?",
        answer: "We offer same-day service for construction debris removal in most Dallas areas. Call us by 10 AM and we can typically be at your site the same day."
      },
      {
        question: "Do you provide dumpster alternatives for renovations?",
        answer: "Yes! Our debris removal service is often more convenient than renting a dumpster. No permit needed, no driveway damage, and you only pay for what we actually haul away."
      },
      {
        question: "Can you remove old cabinets and countertops during a kitchen remodel?",
        answer: "Yes, we regularly help Dallas homeowners and contractors with kitchen and bathroom renovation debris including old cabinets, countertops, fixtures, flooring, and more."
      }
    ],
    ctaText: "Get Contractor-Friendly Pricing",
    pricing: "Custom quotes for construction projects"
  },
  "estate-cleanout": {
    id: "estate",
    slug: "estate-cleanout",
    title: "Estate Cleanout Services Dallas TX | Compassionate Property Clearing",
    metaDescription: "Compassionate estate cleanout services in Dallas, TX. Full property clearing, donation coordination, same-day service. Call 972-330-3678 for caring support.",
    h1: "Estate Cleanout Services in Dallas, TX",
    heroSubtitle: "Compassionate & Thorough Estate Clearing for Dallas Families",
    icon: "Trash2",
    image: "https://images.unsplash.com/photo-1600725935160-f67ee4f6084a?w=1200&auto=format&fit=crop&q=80",
    imageAlt: "Estate cleanout and property clearing service in Dallas",
    shortDescription: "Compassionate and thorough estate clearing services. We handle everything with care and respect.",
    features: ["Full Property Clearing", "Donation Coordination", "Same-Day Service", "Sensitive Item Handling", "Family Coordination", "Property Preparation"],
    sections: [
      {
        h2: "Compassionate Estate Cleanout Services",
        content: "Clearing an estate is never easy. Whether you're managing the property of a loved one who has passed, helping an elderly parent transition to assisted living, or handling a foreclosure property, Dallas Haul Stars approaches every estate cleanout with compassion, respect, and professionalism. We understand the emotional weight of these situations and handle every item with care."
      },
      {
        h2: "Complete Estate Clearing Solutions",
        content: "Our estate cleanout service is comprehensive, handling everything so you don't have to. We can clear an entire property—from furniture and appliances to clothing and personal items—in as little as one day for typical homes.",
        list: [
          "Complete furniture and appliance removal",
          "Personal belongings and clothing",
          "Books, papers, and documents",
          "Kitchen items and housewares",
          "Garage and storage areas",
          "Outdoor items and yard debris",
          "Vehicles and large equipment (coordinated)"
        ]
      },
      {
        h2: "Donation and Charity Coordination",
        content: "Many items in an estate still have value and purpose. Dallas Haul Stars works with local Dallas charities to donate gently used furniture, clothing, housewares, and other items. We handle all the coordination, providing you with donation receipts for tax purposes when possible."
      },
      {
        h2: "Flexible Scheduling for Difficult Times",
        content: "We understand that estate matters often involve court dates, property sales, and family coordination. Dallas Haul Stars offers flexible scheduling to work around your timeline. Whether you need the property cleared in 24 hours or prefer to schedule over several days, we accommodate your needs."
      },
      {
        h2: "Working with Families and Professionals",
        content: "We regularly work with estate attorneys, real estate agents, property managers, and family members to coordinate estate cleanouts. Our team is experienced in navigating the complexities of estate situations and can work with multiple stakeholders to ensure a smooth process."
      }
    ],
    faqs: [
      {
        question: "How long does a complete estate cleanout take?",
        answer: "Most Dallas estate cleanouts can be completed in 1-2 days for a typical single-family home. Larger properties or estates with extensive contents may take longer. We'll provide a timeline estimate during your free consultation."
      },
      {
        question: "Can family members take items before the cleanout?",
        answer: "Absolutely. We recommend families walk through the property first to identify keepsakes, valuable items, or sentimental belongings. We can schedule our cleanout after the family has had time to select what they want to keep."
      },
      {
        question: "Do you buy items from estates?",
        answer: "While we don't typically purchase items, we can help coordinate with estate sale companies or antique buyers for valuable items. Our focus is on efficient, respectful clearing of the property."
      },
      {
        question: "Can you help prepare a property for sale?",
        answer: "Yes! Many Dallas real estate agents partner with us for estate cleanouts before listing properties. A clean, empty home shows better and sells faster."
      },
      {
        question: "What about items with potential value?",
        answer: "Our team is trained to identify items that may have value. We'll alert you to anything we find during the cleanout, giving you the opportunity to have items appraised or sold separately."
      }
    ],
    ctaText: "Schedule a Compassionate Consultation",
    pricing: "Custom quotes based on property size"
  }
};

// Generate JSON-LD Schema for service pages
export const generateServiceSchema = (service, businessInfo) => {
  return {
    "@context": "https://schema.org",
    "@graph": [
      // Local Business Schema
      {
        "@type": "LocalBusiness",
        "@id": `${businessInfo.url}/#organization`,
        "name": businessInfo.name,
        "url": businessInfo.url,
        "logo": businessInfo.logo,
        "image": businessInfo.logo,
        "telephone": businessInfo.phone,
        "priceRange": businessInfo.priceRange,
        "address": {
          "@type": "PostalAddress",
          "streetAddress": businessInfo.address.streetAddress,
          "addressLocality": businessInfo.address.addressLocality,
          "addressRegion": businessInfo.address.addressRegion,
          "postalCode": businessInfo.address.postalCode,
          "addressCountry": businessInfo.address.addressCountry
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": businessInfo.geo.latitude,
          "longitude": businessInfo.geo.longitude
        },
        "openingHoursSpecification": {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
          "opens": "07:00",
          "closes": "19:00"
        },
        "areaServed": businessInfo.areaServed.map(area => ({
          "@type": "City",
          "name": area,
          "addressRegion": "TX"
        })),
        "sameAs": [businessInfo.facebook]
      },
      // Service Schema
      {
        "@type": "Service",
        "@id": `${businessInfo.url}/services/${service.slug}/#service`,
        "name": service.h1,
        "serviceType": service.h1,
        "description": service.metaDescription,
        "provider": {
          "@id": `${businessInfo.url}/#organization`
        },
        "areaServed": {
          "@type": "GeoCircle",
          "geoMidpoint": {
            "@type": "GeoCoordinates",
            "latitude": businessInfo.geo.latitude,
            "longitude": businessInfo.geo.longitude
          },
          "geoRadius": "50"
        },
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": service.h1,
          "itemListElement": service.features.map((feature, index) => ({
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": feature
            }
          }))
        }
      },
      // FAQ Schema
      {
        "@type": "FAQPage",
        "@id": `${businessInfo.url}/services/${service.slug}/#faq`,
        "mainEntity": service.faqs.map(faq => ({
          "@type": "Question",
          "name": faq.question,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": faq.answer
          }
        }))
      },
      // Breadcrumb Schema
      {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": businessInfo.url
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Services",
            "item": `${businessInfo.url}/#services`
          },
          {
            "@type": "ListItem",
            "position": 3,
            "name": service.h1,
            "item": `${businessInfo.url}/services/${service.slug}`
          }
        ]
      },
      // WebPage Schema for AEO/GEO
      {
        "@type": "WebPage",
        "@id": `${businessInfo.url}/services/${service.slug}`,
        "url": `${businessInfo.url}/services/${service.slug}`,
        "name": service.title,
        "description": service.metaDescription,
        "isPartOf": {
          "@id": `${businessInfo.url}/#website`
        },
        "about": {
          "@id": `${businessInfo.url}/services/${service.slug}/#service`
        },
        "breadcrumb": {
          "@id": `${businessInfo.url}/services/${service.slug}/#breadcrumb`
        },
        "speakable": {
          "@type": "SpeakableSpecification",
          "cssSelector": ["h1", ".hero-subtitle", ".faq-answer"]
        }
      }
    ]
  };
};

export default SERVICES_DATA;
